import styled from "styled-components";
import { Link } from "react-router-dom";

export const QuestionnairesContainer = styled.div`
  margin: 0 auto 20px;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const QuestionnaireLink = styled(Link)`
  margin-right: 10px;
  padding-right: 10px;
  font-size: 16px;
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  color: ${({ color }) => color && color};
  border: none;
  border-right: ${({ border }) => border && border};
  text-decoration: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
